<template>
    <div class="animated fadeIn">
        <div class="kgr-row">
            <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row">
                <div class="kgr-postfix__fluid">
                </div>
                <div v-if="canCreate" class="kgr-postfix__fixed">
                    <button
                        class="kgr-button kgr-button--accent"
                        @click="openExamDialog"
                    >
                        <kgr-icon
                            icon-class="add"
                            small
                            circle
                            highlight
                            class="kgr-button__icon kgr-button__icon--left"
                        />
                        <span>{{ $t('Prüfung ablegen') }}</span>
                    </button>
                </div>
            </div>
            <div class="kgr-grid kgr-grid--columnGutters kgr-grid--inlineBlock">
            </div>
        </div>
        <kgr-exam-result-filter
            :club-id="clubId"
            :loading="loading"
            :examinee-type="examineeType"
            storage-key="dogExamResultFilter"
            @onFilter="loadDogExams($event)"
        />
        <hr class="kgr-separator" />
        <div>
            <kgr-dog-exams-list
                :exams="exams"
                :dog-id="dogId"
                :loading="loading"
                :canEdit="canEdit"
                view="list"
            />
        </div>
        <kgr-exam-create-dialog
            :show="showExamDialog"
            :club-id="clubId"
            :loading="pendingCreate"
            :examinee-type="examineeType"
            @onClose="closeExamDialog"
            @onCreate="createDogExam($event)"
        />
    </div>
</template>

<script>
import ClubExam from '../../js/dto/club/ClubExam.js'
import DogExamsList from '../../components/dog/DogExamsList.vue';
import DogRepository from '../../js/repository/DogRepository.js';
import ExamCreateDialog from '../../components/exams/ExamCreateDialog.vue';
import ExamResultFilter from '../../components/exams/ExamResultFilter.vue';
import KgrIcon from '../../components/common/icon/Icon.vue';

export default {
    components: {
        'kgr-dog-exams-list': DogExamsList,
        'kgr-exam-create-dialog': ExamCreateDialog,
        'kgr-exam-result-filter': ExamResultFilter,
        'kgr-icon': KgrIcon,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        dogId: {
            type: String,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true,
        },
        canCreate: {
            type: Boolean,
            required: false,
            default: false
        },
        canEdit: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            showExamDialog: false,
            loading: false,
            pendingCreate: false,
            exams: [],
            examineeType: ClubExam.EXAMINEE_TYPE_DOG,
        };
    },
    created() {
        this.loadDogExams();
    },
    methods: {
        openExamDialog() {
            this.showExamDialog = true;
        },
        closeExamDialog() {
            this.showExamDialog = false;
        },
        createDogExam(exam) {
            this.pendingCreate = true;
            DogRepository.createDogExam(this.dogId, exam.id)
                .then((id) => {
                    window.location = `/backend/clubs/dogs/${this.dogId}/exams/${id}/edit`;
                })
                .catch(() => this.$notify.error('Prüfung konnte nicht angelegt werden'))
                .finally(() => {
                    this.showExamDialog = false;
                });
        },
        loadDogExams(filter) {
            this.loading = true;
            DogRepository.findAllExamResults(this.dogId, filter)
                .then((exams) => this.exams = exams)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
